import { DownloadOutlined, LoadingOutlined } from '@ant-design/icons';
import { useMainContext } from '../../../hooks/useMainContext';
import { PdfUtils } from '../../../utils/PdfUtils';
import { Spin } from 'antd';
import { useState } from 'react';

const PredictClosetButton = () => {
    const { closetManager, apiManager } = useMainContext();
    const [isLoading, setIsLoading] = useState(false);
    async function fetchClosetDataFromJSON(url) {
        const res = await fetch(url);
        if (!res.ok) throw new Error('Failed to fetch JSON');
        return await res.json(); // this should be the closetData array
    }
    const handleDownload = async () => {
        setIsLoading(true);
        const pdfFile = closetManager.pdfBuffer;
        if (!pdfFile) {
            console.error('Invalid pdfFile:', pdfFile);
            throw new Error(
                'PDF file is invalid or not available. Expected a File instance.',
            );
        }
        try {
            let buffer =
                closetManager.pdfBuffer instanceof File
                    ? await closetManager.pdfBuffer.arrayBuffer()
                    : closetManager.pdfBuffer;

            if (!buffer) {
                throw new Error('No valid PDF file loaded.');
            }
            const file = new File([buffer], 'selected_pages.pdf', {
                type: 'application/pdf',
            });
            const fileArrayBuffer = await file.arrayBuffer();
            const pdfBytes = await PdfUtils.createPdfWithSelectedPages(
                fileArrayBuffer,
                [closetManager.selectedPageNo],
                false,
            );
            const pdfFile = new File([pdfBytes], 'selected_pages.pdf', {
                type: 'application/pdf',
            });
            const apiResponse = await apiManager.predictClosets(
                pdfFile,
                closetManager.selectedPageNo,
            );
            const jsonUrl = apiResponse.annotated_output;
            const closetData = await fetchClosetDataFromJSON(jsonUrl);
            closetManager.drawPredictedClosets(
                closetData,
                5000,
                5000,
                closetManager.selectedPageNo,
            );
            setIsLoading(false);
        } catch (error) {
            console.error('Error processing PDF document:', error);
            console.warn(
                'Failed to process trimmed PDF, continuing without trimmed_pdf',
            );
            setIsLoading(false);
        }
    };

    return (
        <div className="absolute top-[5px] right-[24px] min-h-[25px] min-w-[40px] rounded-[8px] group z-50 border-[1px] border-theme-button-bg hover:bg-theme-button-bg">
            <button
                icon={<DownloadOutlined />}
                onClick={handleDownload}
                className="px-3  text-base">
                {isLoading ? (
                    <Spin
                        indicator={
                            <LoadingOutlined
                                spin
                                style={{ color: 'black', fontSize: 24 }}
                            />
                        }
                        size="large"
                    />
                ) : (
                    'Predict Closet'
                )}
            </button>
        </div>
    );
};

export default PredictClosetButton;
